import { useEffect, useRef, useState } from 'react';

/** Delay before a finished activity cluster collapses to its summary line. */
export const ACTIVITY_SETTLE_DELAY_MS = 4000;

/**
 * Returns true `delayMs` after `done` becomes true. If `done` was already
 * true at mount (e.g. thread history reload), settles immediately. Resets
 * whenever `done` flips back to false (new activity arrived).
 */
export function useDelayedSettle(done: boolean, delayMs: number): boolean {
  const doneAtMountRef = useRef(done);
  const [settled, setSettled] = useState(done);

  useEffect(() => {
    if (!done) {
      doneAtMountRef.current = false;
      setSettled(false);
      return;
    }
    if (doneAtMountRef.current) {
      setSettled(true);
      return;
    }
    const timer = setTimeout(() => setSettled(true), delayMs);
    return () => clearTimeout(timer);
  }, [done, delayMs]);

  return settled;
}
